import React, {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useContext,
  useState,
} from 'react'

import { Policyholder } from '../../../domain'
import { useErrorHandlingAsync } from '../../../hooks/errors'
import { usePrincipal } from '../PrincipalProvider'

interface PolicyholderContextObj {
  refresh: () => void
  policyholder: Policyholder | undefined
  setPolicyholder: (policyholder: Policyholder) => void
}

export const PolicyholderContext = createContext<PolicyholderContextObj | undefined>(
  undefined,
)

export const PolicyholderProvider: FunctionComponent<PropsWithChildren> = (props) => {
  const { apiClient, user } = usePrincipal()

  const [policyholder, setPolicyholder] = useState<Policyholder | undefined>(undefined)

  const { execute: refresh } = useErrorHandlingAsync(async () => {
    setPolicyholder(await apiClient.getPolicyholder())
  }, [user])

  return (
    <PolicyholderContext.Provider value={{ policyholder, setPolicyholder, refresh }}>
      {props.children}
    </PolicyholderContext.Provider>
  )
}

export const usePolicyholder = (): PolicyholderContextObj => {
  const context = useContext(PolicyholderContext)
  if (!context) {
    throw new Error('Cannot use PolicyholderContext when undefined.')
  }
  return context
}
